import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {DietaryIndicatorSearchModel} from "../dietary-indicator-search.model";
import {DietaryIndicatorEntityModel} from "../dietary-indicator-entity.model";
import {DietaryIndicatorEditPageComponent} from "../dietary-indicator-edit-page/dietary-indicator-edit-page.component";

@Component({
    selector: "wbo-dietary-indicator-search-page",
    templateUrl: "./dietary-indicator-search-page.component.html",
    providers: [provideSearchModel(DietaryIndicatorSearchModel), provideEntityModel(DietaryIndicatorEntityModel)]
})
export class DietaryIndicatorSearchPageComponent extends AbstractSearchPage {

    editPage = DietaryIndicatorEditPageComponent;

    constructor() {
        super();
    }
}
